import * as React from 'react';
import * as styles from './TermCheckbox.css';
import { IATreeview } from '../treeview/Treeview';
import { ITreeViewItem } from '../../interfaces/ITreeViewItem';
import { IInstance } from '../../interfaces/IInstance';


export interface IATermCheckboxIEProps {
  label?: string;
  token: string;
  tenant?: string;
  instance?: IInstance;
  environment?: "Development" | "Test" | "Production",
  component?: string;
  hideCheckbox?: boolean; 
  selectedValues?: any[];
  highlightColor: string;
  loadData: () => Promise<any[]>;
  onChange: (selectedNodes: any[]) => void;
}

export interface IATermCheckboxIEState {
  availableCategoriesForComponent?: any[];
}

export class IATermCheckboxIE extends React.Component<IATermCheckboxIEProps, IATermCheckboxIEState> {

  private selectedCategories?: any[];

  public constructor(props: IATermCheckboxIEProps) {
    super(props);
    this.state = {
    };
  }

  public componentDidMount(): void {
    this.loadData();
  }

  private childrenCategoriesAreChecked(category: any, id: string): void {
    if (category.children) {
      category.children.forEach((child: any) => {
        if (id === child.guid) {
          child.checked = true;
        }
        this.childrenCategoriesAreChecked(child, id);
      });
    }
  }

  private loadData(): void {
    this.props.loadData().then((result) => {
      if (result && result[0] && result[0].data) {
        if (this.props.selectedValues) {
          this.props.selectedValues.forEach((selectedCategory: any) => {
            result[0].data.items.forEach((category: any) => {
              if (selectedCategory.id === category.guid) {
                category.checked = true;
              }
              this.childrenCategoriesAreChecked(category, selectedCategory.id);
            });
          });
        }
        this.setState({
          availableCategoriesForComponent: result[0].data.items
        });
      }
    });
  }

  private hasSelectedChild(item: ITreeViewItem): void {
    item.children?.forEach((child: ITreeViewItem) => {
      if (child.checked) {
        this.selectedCategories.push(
          {
            id: child.guid,
            name: child.name
          }
        );
      }
      this.hasSelectedChild(child);
    });
  }

  public render() {
    return (
      <div
        className={styles.panelGrid}
      >
        <div>
          <span>{this.props.label}</span>
        <IATreeview
          highlightColor={this.props.highlightColor}
          actionType={this.props.hideCheckbox ? undefined : "Checkbox"}
          expanded={false}
          structureType="Arrow"
          onChange={(items: ITreeViewItem[]) => {
            this.selectedCategories = [];
            this.setState({ availableCategoriesForComponent: items }, () => {
              items.forEach((item: ITreeViewItem) => {
                if (item.checked) {
                  this.selectedCategories.push({
                    id: item.guid,
                    name: item.name
                  })
                }
                this.hasSelectedChild(item);
              });
              this.props.onChange(this.selectedCategories);
            });
          }}
          items={this.state.availableCategoriesForComponent}
        />
        </div>
      </div>
    );
  }
}